import { Modal, Radio, RadioChangeEvent } from "antd";
import { FC, useState } from "react";
import { IShippingAddress } from "types/address";
import AddressCardDetail from "./AddressCardDetail";
import AddUserAddressModal from "./AddUserAddressModal";
import { useAddShippingAddress } from "services/address";
import { Plus } from "lucide-react";

interface ISelectUserAddressModal {
  open: boolean;
  onOk: (selectedId: number) => void;
  onCancel: () => void;
  onSelectAddress: (value: number) => void;
  isLoading?: boolean;
  addressList: IShippingAddress[];
  selectedAddressId: number;
}
const SelectUserAddressModal: FC<ISelectUserAddressModal> = ({
  open,
  onOk,
  onCancel,
  onSelectAddress,
  isLoading,
  addressList,
  selectedAddressId,
}) => {
  const [selectedId, setSelectedId] = useState<number>(selectedAddressId);
  const [isModalAddressOpen, setIsModalAddressOpen] = useState<boolean>(false);
  const { addShippingAddressAsync, isPending } = useAddShippingAddress();

  const onChange = (e: RadioChangeEvent) => {
    setSelectedId(e.target.value as number);
  };

  const handleOnOk = () => {
    onSelectAddress(selectedId);
    onOk(selectedId);
  };

  const showModalAddress = () => {
    setIsModalAddressOpen(true);
  };

  const handleModalAddressOk = async (value: IShippingAddress) => {
    await addShippingAddressAsync(value);
    setIsModalAddressOpen(false);
  };

  const handleModalAddressCancel = () => {
    setIsModalAddressOpen(false);
  };
  return (
    <Modal
      open={open}
      onOk={handleOnOk}
      onCancel={onCancel}
      cancelText="ยกเลิก"
      okText="บันทึก"
      width={550}
      confirmLoading={isLoading}
      title="ที่อยู่ของฉัน"
    >
      <Radio.Group value={selectedId} onChange={onChange} className="w-full">
        {addressList.map((address) => (
          <AddressCardDetail
            key={address.id}
            data={address}
            selectedId={selectedAddressId}
          />
        ))}
      </Radio.Group>
      <div onClick={showModalAddress}>
        <div className="pl-8 mt-4 text-center flex justify-center cursor-pointer gap-1">
          <Plus />
          <div className="underline">เพิ่มที่อยู่</div>
        </div>
      </div>
      <AddUserAddressModal
        open={isModalAddressOpen}
        onOk={handleModalAddressOk}
        onCancel={handleModalAddressCancel}
        isLoading={isPending}
      />
    </Modal>
  );
};

export default SelectUserAddressModal;
